import { classes } from "@theme/helpers";
import { HTMLCustomElement } from "@theme/html-custom-element";

class ProductCard extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.swiper) {
      new Swiper(this.refs.swiper, {
        navigation: {
          nextEl: this.refs.next,
          prevEl: this.refs.prev,
        },
        scrollbar: {
          el: this.refs.scrollbar,
        },
        loop: true,
      });
    }
  }
}

if (!customElements.get("product-card"))
  customElements.define("product-card", ProductCard);
